import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Core components
import Card from 'components/core/Card';
// Custom
import { HEADER_HEIGHT, CARD_HEADER_HEIGHT } from 'constants/App';
import { refreshList } from 'actions';
import { RefreshIconButton } from 'components/buttons/IconButtons';
import ListTemplate from './ListTemplate';

const SubListCardTemplate = ({
  stickHeaderToTop, title, headerAvatar, displayRefresh, actionButtons, additionalHeader, additionalContent, handleRefreshList, ...otherProps
}) => {
  // Add refresh button to title if necessary
  const builtTitle = displayRefresh ? (
    <div className="d-flex align-items-center">
      {title}
      <div className="ml-1">
        <RefreshIconButton onClick={handleRefreshList} />
      </div>
    </div>
  ) : title;

  return (
    <Card
      title={builtTitle}
      padding={stickHeaderToTop ? 'topOnly' : 'none'}
      stickyHeader={{ top: HEADER_HEIGHT }}
      headerAvatar={headerAvatar}
      headerAction={(
        <div className="d-flex flex-wrap align-items-center">
          {actionButtons}
          {additionalHeader}
        </div>
      )}
    >
      <React.Fragment>
        {additionalContent}
        <ListTemplate
          stickyHeader={{ top: stickHeaderToTop ? 0 : HEADER_HEIGHT + CARD_HEADER_HEIGHT }}
          withBorder={false}
          {...otherProps}
        />
      </React.Fragment>
    </Card>
  );
};

SubListCardTemplate.propTypes = {
  stickHeaderToTop: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerAvatar: PropTypes.node,
  displayRefresh: PropTypes.bool,
  actionButtons: PropTypes.node,
  additionalHeader: PropTypes.node,
  additionalContent: PropTypes.element,
  handleRefreshList: PropTypes.func.isRequired,
};

SubListCardTemplate.defaultProps = {
  stickHeaderToTop: false,
  title: null,
  headerAvatar: null,
  displayRefresh: false,
  actionButtons: null,
  additionalHeader: null,
  additionalContent: null,
};

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
});

module.exports = connect(
  null,
  mapDispatchToProps,
)(SubListCardTemplate);



// WEBPACK FOOTER //
// ./components/templates/SubListCardTemplate.js